import { useEffect } from "react";

// Lightweight SEO: sets title + meta description + og tags per page.
export const Seo = ({ title, description }) => {
  useEffect(() => {
    const full = `${title} | Next Mile Compliance LLC`;
    document.title = full;
    const set = (sel, attr, val) => {
      let el = document.head.querySelector(sel);
      if (!el) {
        el = document.createElement("meta");
        const [a, v] = sel.includes("property") ? ["property", sel.match(/"(.*?)"/)[1]] : ["name", sel.match(/"(.*?)"/)[1]];
        el.setAttribute(a, v);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, val);
    };
    if (description) set('meta[name="description"]', "content", description);
    set('meta[property="og:title"]', "content", full);
    if (description) set('meta[property="og:description"]', "content", description);
    set('meta[property="og:type"]', "content", "website");
  }, [title, description]);
  return null;
};
